// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper {
  width: 100%;
}
.stepper .step-item {
  flex: 0 1;
  min-width: fit-content;
  width: fit-content;
  align-items: baseline;
  color: var(--primary-color-main);
  transition: color 0.8s;
}
.stepper .step-item.disable {
  color: var(--disabled-font-color);
}
.stepper .step-item .icon {
  margin: 0 auto;
  position: relative;
  z-index: var(--z-index-local-over-2);
}
.stepper .step-item .icon::before {
  position: absolute;
  background-color: var(--white-color-lightest);
  content: "";
  width: 50%;
  height: 50%;
  border-radius: 50%;
  top: 0%;
  left: 0%;
  bottom: 0%;
  right: 0%;
  margin: auto;
  z-index: var(--z-index-local-under-1);
}
.stepper .line-item {
  width: 100%;
  flex: 1 1;
  align-items: baseline;
  color: var(--primary-color-main);
}
.stepper .line-item .line-image {
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background-color: var(--primary-color-main);
  margin-bottom: 24px;
  transition: background-color 0.3s;
}
.stepper .line-item.disable .line-image {
  background-color: var(--disabled-font-color);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Stepper.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,sBAAA;AACR;AACQ;EACI,iCAAA;AACZ;AAEQ;EACI,cAAA;EACA,kBAAA;EACA,oCAAA;AAAZ;AAEY;EACI,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,qCAAA;AAAhB;AAKI;EACI,WAAA;EACA,SAAA;EACA,qBAAA;EACA,gCAAA;AAHR;AAKQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,iCAAA;AAHZ;AAOY;EACI,4CAAA;AALhB","sourcesContent":[".stepper{\r\n    width: 100%;\r\n\r\n    .step-item {\r\n        flex: 0;\r\n        min-width: fit-content;\r\n        width: fit-content;\r\n        align-items: baseline;\r\n        color: var(--primary-color-main);\r\n        transition: color 0.8s;\r\n    \r\n        &.disable {\r\n            color: var(--disabled-font-color);\r\n        }\r\n    \r\n        .icon {\r\n            margin: 0 auto;\r\n            position: relative;\r\n            z-index: var(--z-index-local-over-2);\r\n\r\n            &::before{\r\n                position: absolute;\r\n                background-color: var(--white-color-lightest);\r\n                content: \"\";\r\n                width: 50%;\r\n                height: 50%;\r\n                border-radius: 50%;\r\n                top: 0%;\r\n                left: 0%;\r\n                bottom: 0%;\r\n                right: 0%;\r\n                margin: auto;\r\n                z-index: var(--z-index-local-under-1);\r\n            }\r\n        }\r\n    }\r\n\r\n    .line-item{\r\n        width: 100%;\r\n        flex: 1;\r\n        align-items: baseline;\r\n        color: var(--primary-color-main);\r\n\r\n        .line-image {\r\n            width: 100%;\r\n            height: 2px;\r\n            border-radius: 2px;\r\n            background-color: var(--primary-color-main);\r\n            margin-bottom: 24px;\r\n            transition: background-color 0.3s;\r\n        }\r\n\r\n        &.disable {\r\n            .line-image {\r\n                background-color: var(--disabled-font-color);\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
